/* Save Design (2026-09-25 package: Artisticases-Save-Design-Claude). Loaded
   once from layout/theme.liquid after ac-wishlist.js.

   The theme's store-lists engine stays the one saved set: entries are
   { variantId: handle } pairs in localStorage (wishlist-guest, or
   wishlist-customer-<id> mirrored to the vendor lists app for signed-in
   customers), and its checkProductStatus / updateHeaderCount paint every
   heart and the header count. Nothing here stores saved designs.

   This file wraps the engine instance's addItem / removeItem. A save counts
   only when the entry is in storage after the call; that is the moment
   design_saved / design_unsaved are sent, the feedback runs and the
   first-save flag is written. A write that throws (storage full or
   blocked) rolls the hearts back from storage and shows the failure copy.
   The engine's customer sync to the lists app has no failure callback and
   is reconciled by the engine on the next page load, as before.

   Feedback after a confirmed save:
   - first save in this browser (flag ac_save_intro_seen_v1 unset): the
     "Design saved" card, below the header heart on wider screens, a bottom
     toast on phones; 6 s of visible, unfocused time, pauses on hover,
     focus and hidden tabs
   - every later save: heart pop, count badge pulse, a "Saved" pill by the
     tapped control for 1.2 s
   Visitors who already have saved designs are treated as introduced.

   Also here: accessible names and aria-pressed on every heart, the desktop
   "Save design" / "Remove saved design" tooltip on icon-only hearts, the
   polite announcement per mutation, and the Hub events (TRACKING-AND-QA.md),
   sent through window.acTrack from snippets/ac-wishlist-track.liquid. */
(function () {
  'use strict';

  var COPY = {
    save: 'Save design',
    remove: 'Remove saved design',
    saved: 'Saved',
    savedSuffix: ' saved',
    removedSuffix: ' removed from saved designs',
    introTitle: 'Design saved',
    introBody: 'Keep browsing. Your favorites are in the heart at the top.',
    introAction: 'View saved designs',
    dismiss: 'Dismiss notification',
    saveFailed: "Couldn't save this design. Please try again.",
    removeFailed: "Couldn't remove this design. Please try again."
  };
  var INTRO_KEY = 'ac_save_intro_seen_v1';
  var INTRO_VERSION = 1;
  var SCHEMA_VERSION = 1;
  var INTRO_MS = 6000;
  var PILL_MS = 1200;
  var TIP_DELAY = 300;
  var CONTROL = '.js-store-lists-add-wishlist';
  var HEADER_BUTTON = '[data-js-popup-button="wishlist"]';

  var ctx = window.acSaveContext || {};
  var memory = {};
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var finePointer = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: true };

  function rid(prefix) {
    var s = '';
    try {
      var a = new Uint8Array(12);
      window.crypto.getRandomValues(a);
      for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2);
    } catch (e) { s = Date.now().toString(36) + Math.random().toString(36).slice(2, 14); }
    return prefix + s;
  }
  var pageviewId = rid('pv_');

  /* ---- UI state (never saved-design data) ------------------------------- */

  function flagGet(key) {
    try { var v = window.localStorage.getItem(key); if (v !== null) return v; } catch (e) { /* blocked */ }
    return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null;
  }
  function flagSet(key, value) {
    memory[key] = value;
    try { window.localStorage.setItem(key, value); } catch (e) { /* in-memory for this page */ }
  }
  function introSeen() { return !!flagGet(INTRO_KEY); }
  function markIntroSeen() { flagSet(INTRO_KEY, new Date().toISOString()); }

  /* ---- engine access ---------------------------------------------------- */

  function engine() {
    var t = window.theme;
    return t && t.StoreLists && t.StoreLists.lists && t.StoreLists.lists.wishlist;
  }
  function entries(list) {
    try {
      var raw = window.localStorage.getItem(list.current_storage);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (e) { return null; }
  }
  function isSaved(list, id, handle) {
    var items = entries(list);
    if (!items) return false;
    for (var i = 0; i < items.length; i++) {
      var entry = items[i];
      if (id && entry && entry[id] === handle) return true;
      if (!id && entry && entry[Object.keys(entry)[0]] === handle) return true;
    }
    return false;
  }
  function savedCount(list) { var items = entries(list); return items ? items.length : null; }
  function savedHandles(list) {
    var out = {}, items = entries(list) || [];
    items.forEach(function (entry) { Object.keys(entry || {}).forEach(function (k) { out[entry[k]] = k; }); });
    return out;
  }

  /* ---- context: which control started the mutation ---------------------- */

  var lastControl = null;
  /* window capture: runs before ac-wishlist.js, whose document capture handler
     removes a drawer row synchronously */
  window.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var el = e.target.closest(CONTROL + ', [data-ac-wd-remove], .js-store-lists-remove-wishlist');
    if (!el || el.hasAttribute('data-ac-pending')) return;
    hideTip();
    el._acTipOff = true;   /* no tooltip again until the pointer leaves (the icon swap fires a new mouseover) */
    lastControl = { el: el, at: Date.now() };
  }, true);

  function sourceFor(el) {
    if (!el) return null;
    if (el.closest('.ac-wd, .popup-wishlist, .popup-wishlist-full')) return 'saved_drawer';
    if (el.classList.contains('ac-product-top-wishlist') || el.closest('.product-page-info__button-add-to-wishlist')) return 'product_page';
    return 'collection_card';
  }
  function titleFor(el, handle) {
    if (el) {
      var own = el.getAttribute('data-ac-title');
      if (own) return own;
      var row = el.closest('[data-title]');
      if (row && row.getAttribute('data-title')) return row.getAttribute('data-title');
      var card = el.closest('[data-ac-card], .ac-home-trend__card, .product-collection, .product-wishlist');
      var t = card && card.querySelector('.ac-col-card__name, .ac-home-trend__name, .product-collection__title, .product-wishlist__title');
      if (t && t.textContent.trim()) return t.textContent.trim();
    }
    var h1 = document.querySelector('.product-page-info__title h1');
    if (h1 && ctx.productHandle === handle) return h1.textContent.trim();
    return handle;
  }
  function takeContext(id, handle) {
    var c = lastControl;
    lastControl = null;
    var el = c && Date.now() - c.at < 3000 ? c.el : null;
    if (el) {
      var h = el.getAttribute('data-product-handle') || (el.closest('[data-product-handle]') || el).getAttribute('data-product-handle');
      if (h && h !== handle) el = null;
    }
    return { el: el, source: sourceFor(el) || 'collection_card', title: titleFor(el, handle), handle: handle, id: id, operation: rid('op_') };
  }

  /* ---- tracking ---------------------------------------------------------- */

  function deviceType() { return window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'; }

  function track(name, fields) {
    try {
      if (!window.acTrack || typeof window.acTrack.send !== 'function') return;
      var ev = {
        event_id: rid('ev_'),
        event_name: name,
        occurred_at: new Date().toISOString(),
        schema_version: SCHEMA_VERSION,
        page_type: ctx.pageType || null,
        pathname: location.pathname,
        device_type: deviceType(),
        pageview_id: pageviewId
      };
      for (var k in fields) if (Object.prototype.hasOwnProperty.call(fields, k) && fields[k] !== undefined) ev[k] = fields[k];
      window.acTrack.send(ev);
    } catch (e) { /* analytics never blocks saving */ }
  }
  function productFields(op) {
    return { product_handle: op.handle, product_title: op.title, variant_id: op.id ? String(op.id) : null };
  }

  /* ---- live region ------------------------------------------------------- */

  var live = null;
  function announce(message, assertive) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'ac-save-live';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      document.body.appendChild(live);
    }
    live.setAttribute('aria-live', assertive ? 'assertive' : 'polite');
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 60);
  }

  /* ---- accessible state on every control -------------------------------- */

  function refreshControls(scope) {
    var list = (scope && scope.querySelectorAll ? scope : document).querySelectorAll(CONTROL);
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var saved = el.getAttribute('data-button-status') === 'added';
      var handle = el.getAttribute('data-product-handle');
      if (!el.hasAttribute('data-ac-title')) {
        var t = titleFor(el, handle);
        if (t && t !== handle) el.setAttribute('data-ac-title', t);
      }
      var title = el.getAttribute('data-ac-title') || '';
      el.setAttribute('role', 'button');
      el.setAttribute('aria-pressed', saved ? 'true' : 'false');
      el.setAttribute('aria-label', (saved ? COPY.remove : COPY.save) + (title ? ': ' + title : ''));
      el.removeAttribute('title');
    }
  }

  /* anchors with role=button: Space activates as well as Enter */
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' || !e.target || !e.target.matches || !e.target.matches(CONTROL)) return;
    e.preventDefault();
    e.target.click();
  });

  /* ---- motion ------------------------------------------------------------ */

  function pop(el) {
    if (!el || reduceMotion.matches) return;
    el.classList.remove('ac-save-pop');
    void el.offsetWidth;
    el.classList.add('ac-save-pop');
  }
  function pulseCount() {
    if (reduceMotion.matches) return;
    var counters = document.querySelectorAll('[data-js-wishlist-count]');
    for (var i = 0; i < counters.length; i++) pop(counters[i]);
  }
  function visible(el) {
    if (!el || !el.isConnected) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  }

  /* ---- Saved pill (and the error note, same spot) ----------------------- */

  var pill = null, pillTimer = null;
  function clearPill() {
    window.clearTimeout(pillTimer);
    if (pill) { pill.remove(); pill = null; }
  }
  function placeNear(node, anchor) {
    var vw = document.documentElement.clientWidth;
    var r = anchor.getBoundingClientRect();
    var w = node.offsetWidth, h = node.offsetHeight;
    var left = r.left + r.width / 2 - w / 2;
    left = Math.max(8, Math.min(left, vw - w - 8));
    var top = r.bottom + 6;
    if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 6);
    node.style.left = Math.round(left) + 'px';
    node.style.top = Math.round(top) + 'px';
  }
  function showPill(anchor, text, kind, ms) {
    clearPill();
    if (!visible(anchor)) anchor = headerButton();
    if (!anchor) return false;
    pill = document.createElement('span');
    pill.className = 'ac-save-pill' + (kind ? ' ac-save-pill--' + kind : '');
    pill.setAttribute('aria-hidden', 'true');
    pill.textContent = text;
    document.body.appendChild(pill);
    placeNear(pill, anchor);
    var node = pill;
    pillTimer = window.setTimeout(function () { if (pill === node) clearPill(); }, ms);
    return true;
  }

  /* ---- tooltip (desktop, icon-only hearts) ------------------------------ */

  var tip = null, tipTimer = null, tipFor = null;
  function hideTip() {
    window.clearTimeout(tipTimer);
    if (tipFor) tipFor.removeAttribute('aria-describedby');
    tipFor = null;
    if (tip) tip.hidden = true;
  }
  function scheduleTip(el) {
    if (!finePointer.matches || !el.hasAttribute('data-ac-heart') || el._acTipOff) return;
    window.clearTimeout(tipTimer);
    tipTimer = window.setTimeout(function () {
      if (pill || !visible(el)) return;
      if (!tip) {
        tip = document.createElement('span');
        tip.className = 'ac-save-tip';
        tip.id = 'ac-save-tip';
        tip.setAttribute('role', 'tooltip');
        document.body.appendChild(tip);
      }
      tip.textContent = el.getAttribute('data-button-status') === 'added' ? COPY.remove : COPY.save;
      tip.hidden = false;
      placeNear(tip, el);
      tipFor = el;
      el.setAttribute('aria-describedby', 'ac-save-tip');
    }, TIP_DELAY);
  }
  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest && e.target.closest(CONTROL);
    if (el && el !== tipFor) scheduleTip(el);
  });
  document.addEventListener('mouseout', function (e) {
    var el = e.target.closest && e.target.closest(CONTROL);
    if (el && !(e.relatedTarget && el.contains(e.relatedTarget))) { el._acTipOff = false; hideTip(); }
  });
  document.addEventListener('focusin', function (e) {
    var el = e.target.closest && e.target.closest(CONTROL);
    if (el && el.matches(':focus-visible')) scheduleTip(el);
  });
  document.addEventListener('focusout', function (e) {
    var el = e.target.closest && e.target.closest(CONTROL);
    if (el) { el._acTipOff = false; hideTip(); }
  });
  window.addEventListener('scroll', hideTip, { passive: true });

  /* ---- first-save introduction ------------------------------------------ */

  var intro = null;
  function headerButton() {
    var list = document.querySelectorAll(HEADER_BUTTON);
    for (var i = 0; i < list.length; i++) if (visible(list[i])) return list[i];
    return null;
  }
  function bottomClearance() {
    /* fixed bottom controls (chat bubble, cookie banner, sticky add-to-bag, preview bar) */
    var vh = window.innerHeight, clear = 0;
    var nodes = document.querySelectorAll('body > *, [class*="sticky"], [data-ac-sticky-bar], #shopify-chat, #shopify-pc__banner');
    for (var i = 0; i < nodes.length && i < 400; i++) {
      var n = nodes[i];
      if (n === intro || n === pill || n === live) continue;
      var cs = window.getComputedStyle(n);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) continue;
      var r = n.getBoundingClientRect();
      if (r.height === 0 || r.width === 0 || r.height > vh * 0.5 || r.bottom < vh - 4 || r.top > vh) continue;
      clear = Math.max(clear, vh - r.top);
    }
    /* Shopify Inbox: <shopify-chat> covers the whole viewport and draws its
       bubble inside a shadow root; measure the bubble, or keep its usual
       56px + gap when the root is closed */
    var chat = document.querySelector('shopify-chat');
    if (chat && window.getComputedStyle(chat).display !== 'none') {
      var bubble = null, root = chat.shadowRoot;
      if (root) {
        var cands = root.querySelectorAll('button, [role="button"], iframe');
        for (var j = 0; j < cands.length; j++) {
          var br = cands[j].getBoundingClientRect();
          if (br.width > 0 && br.height > 0 && br.height < 120 && br.top > vh / 2) { bubble = br; break; }
        }
      }
      clear = bubble ? Math.max(clear, vh - bubble.top + 4) : clear + 72;
    }
    return clear;
  }
  function placeIntro() {
    if (!intro) return;
    intro.el.classList.remove('ac-save-intro--anchored', 'ac-save-intro--toast', 'ac-save-intro--corner');
    intro.el.style.top = intro.el.style.bottom = intro.el.style.right = '';
    var vw = document.documentElement.clientWidth;
    if (deviceType() === 'mobile') {
      intro.el.classList.add('ac-save-intro--toast');
      intro.el.style.bottom = 'calc(' + (12 + bottomClearance()) + 'px + env(safe-area-inset-bottom, 0px))';
      return;
    }
    var heart = headerButton();
    if (heart) {
      var r = heart.getBoundingClientRect();
      intro.el.classList.add('ac-save-intro--anchored');
      intro.el.style.top = Math.round(r.bottom + 10) + 'px';
      intro.el.style.right = Math.round(Math.max(12, vw - r.right - 24)) + 'px';
    } else {
      intro.el.classList.add('ac-save-intro--corner');
    }
  }
  function startIntroTimer() {
    if (!intro) return;
    window.clearTimeout(intro.timer);
    if (intro.hover || intro.focus || document.hidden) return;
    intro.timer = window.setTimeout(function () { dismissIntro('timeout'); }, INTRO_MS);
  }
  function dismissIntro(method) {
    if (!intro) return;
    var it = intro;
    intro = null;
    window.clearTimeout(it.timer);
    var hadFocus = it.el.contains(document.activeElement);
    it.el.remove();
    window.removeEventListener('resize', placeIntro);
    if (hadFocus && method !== 'open_drawer') {
      var back = it.op.el && it.op.el.isConnected ? it.op.el : headerButton();
      if (back) try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
    }
    track('save_intro_dismissed', { source: 'save_intro', dismiss_method: method, intro_version: INTRO_VERSION, operation_id: it.op.operation });
  }
  function showIntro(op, count) {
    var el = document.createElement('div');
    el.className = 'ac-save-intro';
    el.setAttribute('role', 'region');
    el.setAttribute('aria-labelledby', 'ac-save-intro-title');
    el.innerHTML =
      '<span class="ac-save-intro__check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 12.5l3.5 3.5 7.5-8"/></svg></span>' +
      '<div class="ac-save-intro__body">' +
        '<p class="ac-save-intro__title" id="ac-save-intro-title"></p>' +
        '<p class="ac-save-intro__text"></p>' +
        '<button type="button" class="ac-save-intro__action" data-ac-save-open></button>' +
      '</div>' +
      '<button type="button" class="ac-save-intro__close" data-ac-save-dismiss><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    el.querySelector('.ac-save-intro__title').textContent = COPY.introTitle;
    el.querySelector('.ac-save-intro__text').textContent = COPY.introBody;
    el.querySelector('[data-ac-save-open]').textContent = COPY.introAction;
    el.querySelector('[data-ac-save-dismiss]').setAttribute('aria-label', COPY.dismiss);
    document.body.appendChild(el);
    intro = { el: el, op: op, timer: null, hover: false, focus: false };
    placeIntro();
    window.addEventListener('resize', placeIntro);

    el.addEventListener('mouseenter', function () { if (intro) { intro.hover = true; window.clearTimeout(intro.timer); } });
    el.addEventListener('mouseleave', function () { if (intro) { intro.hover = false; startIntroTimer(); } });
    el.addEventListener('focusin', function () { if (intro) { intro.focus = true; window.clearTimeout(intro.timer); } });
    el.addEventListener('focusout', function (e) { if (intro && !el.contains(e.relatedTarget)) { intro.focus = false; startIntroTimer(); } });
    el.querySelector('[data-ac-save-dismiss]').addEventListener('click', function () { dismissIntro('close_button'); });
    el.querySelector('[data-ac-save-open]').addEventListener('click', function () { openDrawer('save_intro'); });

    markIntroSeen();
    startIntroTimer();
    track('save_intro_shown', { source: 'save_intro', feedback_type: 'first_intro', intro_version: INTRO_VERSION, saved_count_after: count, operation_id: op.operation });
  }
  document.addEventListener('visibilitychange', function () {
    if (!intro) return;
    if (document.hidden) window.clearTimeout(intro.timer); else startIntroTimer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    hideTip();
    if (intro && !document.body.classList.contains('popup-opened')) dismissIntro('escape');
  });
  window.addEventListener('pagehide', function () { if (intro) dismissIntro('navigation'); });

  /* ---- drawer ------------------------------------------------------------ */

  var drawerOpen = false, drawerSource = null;
  function openDrawer(source) {
    drawerSource = source;
    if (intro) dismissIntro('open_drawer');
    var t = window.theme;
    if (t && t.Popups && typeof t.Popups.callByName === 'function') {
      t.Popups.callByName('wishlist');
    } else {
      var b = headerButton();
      if (b) b.click();
    }
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest(HEADER_BUTTON) && !drawerOpen) drawerSource = drawerSource || 'header';
    var link = e.target.closest('.ac-wd [data-ac-wd-link]');
    if (link) {
      var row = link.closest('[data-ac-wd-item]');
      var handle = row && row.getAttribute('data-product-handle');
      if (!handle) return;
      try { window.sessionStorage.setItem('ac_save_origin', JSON.stringify({ handle: handle, at: Date.now() })); } catch (err) { /* attribution optional */ }
      track('saved_design_opened', { source: 'saved_drawer', product_handle: handle, product_title: row.getAttribute('data-title') || null, variant_id: row.getAttribute('data-product-variant-id') || null });
    }
  }, true);
  function bindDrawer() {
    var t = window.theme;
    if (!t || !t.Popups || typeof t.Popups.addHandler !== 'function') return false;
    t.Popups.addHandler('wishlist', 'call.after', function () {
      if (drawerOpen) return;
      drawerOpen = true;
      if (intro) dismissIntro('open_drawer');
      var list = engine();
      track('saved_drawer_opened', { source: drawerSource || 'header', saved_count_after: list ? savedCount(list) : null });
      drawerSource = null;
    });
    t.Popups.addHandler('wishlist', 'close.after', function () { drawerOpen = false; });
    return true;
  }

  /* ---- mutations --------------------------------------------------------- */

  function failed(op, action, category) {
    var list = engine();
    if (list) { list.checkProductStatus(); list.updateHeaderCount(); }
    refreshControls();
    if (op.el) op.el.removeAttribute('disabled');
    var message = action === 'save' ? COPY.saveFailed : COPY.removeFailed;
    if (op.source !== 'saved_drawer') showPill(op.el, message, 'error', 4000);
    announce(message, true);
    track('save_action_failed', { action: action, error_category: category, source: op.source, operation_id: op.operation, product_handle: op.handle, variant_id: op.id ? String(op.id) : null });
  }
  function errorCategory(e) {
    var n = e && (e.name || '');
    if (/quota/i.test(n) || (e && e.code === 22)) return 'storage_full';
    if (/security/i.test(n)) return 'storage_blocked';
    return 'unknown';
  }

  function saved(op, list, countBefore) {
    var count = savedCount(list);
    refreshControls();
    pop(op.el);
    pulseCount();
    announce(op.title + COPY.savedSuffix);
    if (window.acTrack && window.acTrack.markSaver) window.acTrack.markSaver();

    var first = !introSeen() && !countBefore;
    if (!introSeen() && countBefore) markIntroSeen();   /* already saving before this shipped */
    var fields = productFields(op);
    fields.source = op.source; fields.operation_id = op.operation; fields.saved_count_after = count;
    fields.feedback_type = first ? 'first_intro' : 'compact';
    track('design_saved', fields);

    if (first) {
      clearPill();
      showIntro(op, count);
      return;
    }
    if (intro) dismissIntro('next_save');
    if (op.source === 'saved_drawer') return;
    hideTip();
    if (showPill(op.el, COPY.saved, null, PILL_MS)) {
      track('save_feedback_shown', { source: op.source, feedback_type: 'compact', operation_id: op.operation, saved_count_after: count, product_handle: op.handle });
    }
  }

  function unsaved(op, list) {
    var count = savedCount(list);
    refreshControls();
    if (pill && !pill.classList.contains('ac-save-pill--error')) clearPill();
    /* the drawer announces its own removal, with the remaining count */
    if (op.source !== 'saved_drawer') announce(op.title + COPY.removedSuffix);
    var fields = productFields(op);
    fields.source = op.source; fields.operation_id = op.operation; fields.saved_count_after = count;
    track('design_unsaved', fields);
  }

  function wrap(list) {
    if (list._acSave) return;
    list._acSave = true;
    var add = list.addItem, remove = list.removeItem, check = list.checkProductStatus;

    list.checkProductStatus = function (products) {
      var out = check.apply(this, arguments);
      try { refreshControls(); } catch (e) { /* cosmetic */ }
      return out;
    };

    list.addItem = function (id, handle, callback) {
      var op = takeContext(id, handle);
      if (isSaved(list, id, handle)) {
        /* already saved (a stale heart or a double tap): repaint, no duplicate, no event */
        list.checkProductStatus(); list.updateHeaderCount();
        if (callback) callback();
        return;
      }
      var before = savedCount(list);
      try { add.call(list, id, handle); } catch (e) { failed(op, 'save', errorCategory(e)); return; }
      if (!isSaved(list, id, handle)) { failed(op, 'save', 'not_persisted'); return; }
      if (callback) callback();
      saved(op, list, before);
    };

    list.removeItem = function (id, handle, callback) {
      var op = takeContext(id, handle);
      var was = isSaved(list, id, handle);
      try { remove.call(list, id, handle); } catch (e) { failed(op, 'remove', errorCategory(e)); return; }
      if (isSaved(list, id, handle)) { failed(op, 'remove', 'not_persisted'); return; }
      if (callback) callback();
      if (was) unsaved(op, list);
      else refreshControls();
    };
  }

  /* ---- exposure: >= 50% in view for 1 continuous second, once per page -- */

  var exposed = {};
  function watchExposure(name, selector, extra) {
    if (exposed[name] || !('IntersectionObserver' in window)) return;
    var timers = new Map();
    var io = new IntersectionObserver(function (records) {
      records.forEach(function (r) {
        if (r.isIntersecting && r.intersectionRatio >= 0.5) {
          if (timers.has(r.target)) return;
          timers.set(r.target, window.setTimeout(function () {
            if (exposed[name] || document.hidden) { timers.delete(r.target); return; }
            exposed[name] = true;
            io.disconnect();
            timers.forEach(function (t) { window.clearTimeout(t); });
            track(name, extra(r.target));
          }, 1000));
        } else if (timers.has(r.target)) {
          window.clearTimeout(timers.get(r.target));
          timers.delete(r.target);
        }
      });
    }, { threshold: [0, 0.5, 1] });
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
    watchExposure[name] = io;
  }
  function observeExposure() {
    if (!exposed.save_control_exposed) {
      if (watchExposure.save_control_exposed) watchExposure.save_control_exposed.disconnect();
      watchExposure.save_control_exposed = null;
      watchExposure('save_control_exposed', CONTROL, function (el) { return { source: sourceFor(el) }; });
    }
    if (!exposed.save_hint_shown && !watchExposure.save_hint_shown) {
      watchExposure('save_hint_shown', '[data-ac-save-hint]', function () { return { source: 'collection_card' }; });
    }
  }
  document.addEventListener('visibilitychange', function () {
    /* a hidden tab cancels the 1 s run; start again when it is back */
    if (!document.hidden) return;
    ['save_control_exposed', 'save_hint_shown'].forEach(function (n) {
      if (exposed[n] || !watchExposure[n]) return;
      watchExposure[n].disconnect();
      watchExposure[n] = null;
    });
    document.addEventListener('visibilitychange', function again() {
      if (document.hidden) return;
      document.removeEventListener('visibilitychange', again);
      observeExposure();
    });
  });

  /* ---- saved design added to the bag ------------------------------------ */

  function origin() {
    try { var o = JSON.parse(window.sessionStorage.getItem('ac_save_origin') || 'null'); return o && o.handle ? o : null; } catch (e) { return null; }
  }
  function cartAdded(items) {
    var list = engine();
    if (!list || !items || !items.length) return;
    var savedNow = savedHandles(list), from = origin();
    items.forEach(function (item) {
      var handle = item && item.handle;
      if (!handle) return;
      var method = from && from.handle === handle ? 'drawer_origin' : (savedNow[handle] ? 'currently_saved_product' : null);
      if (!method) return;
      track('saved_item_added_to_cart', {
        source: method === 'drawer_origin' ? 'saved_drawer' : (ctx.pageType === 'product' ? 'product_page' : 'collection_card'),
        attribution_method: method,
        product_handle: handle,
        product_title: item.product_title || null,
        variant_id: item.variant_id ? String(item.variant_id) : null
      });
    });
  }
  function isCartAdd(url) { return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url.replace(location.origin, '')); }
  function itemsFrom(json) { return json && (json.items || (json.handle ? [json] : null)); }
  (function watchCart() {
    if (window.fetch && !window.fetch.__acSaveCart) {
      var f = window.fetch;
      var wrapped = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = f.apply(this, arguments);
        if (isCartAdd(url)) {
          p.then(function (res) {
            if (!res || !res.ok) return;
            res.clone().json().then(function (json) { cartAdded(itemsFrom(json)); }).catch(function () {});
          }).catch(function () {});
        }
        return p;
      };
      wrapped.__acSaveCart = true;
      window.fetch = wrapped;
    }
    var X = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (X && !X.__acSaveCart) {
      X.__acSaveCart = true;
      var open = X.open;
      X.open = function (method, url) {
        if (isCartAdd(String(url || ''))) {
          this.addEventListener('load', function () {
            if (this.status < 200 || this.status >= 300) return;
            try { cartAdded(itemsFrom(JSON.parse(this.responseText))); } catch (e) { /* not JSON */ }
          });
        }
        return open.apply(this, arguments);
      };
    }
  })();

  /* ---- start ------------------------------------------------------------- */

  function start() {
    var list = engine();
    if (!list) return false;
    wrap(list);
    /* rollout: anyone arriving with saved designs is already introduced */
    if (!introSeen() && savedCount(list) > 0) markIntroSeen();
    refreshControls();
    observeExposure();
    return true;
  }
  /* theme.js arrives with the first mouse move or touch (the asset loader),
     so the engine can appear late; keep checking until it does */
  var started = false, bound = false;
  /* layout/theme.liquid replays an early heart click once the engine exists;
     it calls this first so the replayed save goes through the wrapper */
  window.acSaveReady = function () { if (!started) started = start(); return started; };
  (function wait(tries) {
    if (!started) started = start();
    if (!bound) bound = bindDrawer();
    if (started && bound) return;
    window.setTimeout(function () { wait(tries + 1); }, tries < 100 ? 100 : 400);
  })(0);
  refreshControls();

  document.addEventListener('ac:collection:rendered', function () {
    refreshControls();
    if (!exposed.save_control_exposed) observeExposure();
  });
})();
